module.exports = __webpack_public_path__ + "static/media/coalesse-2.81bf02bc.jpg";